export enum JoinEntryCardType {
  GrowYourBusiness = 'grow-your-business',
  ManageYourBusiness = 'manage-your-business',
  ElevateYourClientExperience = 'elevate-your-client-experience',
  ListYourBusiness = 'list-your-business',
}

export const JoinEntryCardTrackName = {
  [JoinEntryCardType.GrowYourBusiness]: 'join_entry_grow_business_clicked',
  [JoinEntryCardType.ManageYourBusiness]: 'join_entry_manage_business_clicked',
  [JoinEntryCardType.ElevateYourClientExperience]: 'join_entry_elevate_experience_clicked',
  [JoinEntryCardType.ListYourBusiness]: 'join_entry_list_business_clicked',
};

export enum ImageSizes {
  Desktop = 'desktop',
  Tablet = 'tablet',
  TabletNarrow = 'tablet-narrow',
  Phone = 'phone',
}

export const MannyImage = {
  [ImageSizes.Desktop]: {
    imageUrl: 'https://www.styleseat.com/bundles/static/assets/home/landing_page/manny.png',
    height: 489,
    width: 548,
  },
  [ImageSizes.Tablet]: {
    imageUrl: 'https://www.styleseat.com/bundles/static/assets/home/landing_page/manny_tablet.png',
    height: 450,
    width: 361,
  },
  [ImageSizes.TabletNarrow]: {
    imageUrl: 'https://www.styleseat.com/bundles/static/assets/home/landing_page/manny_tablet.png',
    height: 410,
    width: 290,
  },
  [ImageSizes.Phone]: {
    imageUrl: 'https://www.styleseat.com/bundles/static/assets/home/landing_page/manny_mobile.png',
    height: 446,
    width: 326,
  },
};
